import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from './theme';

export const TRIAL_LENGTH_DAYS = 14;
export const PLUS_WELCOME_HUB_VISIBILITY_WINDOW_DAYS = 14;
export const MEMBERSHIP_COST = 69;
export const CARRIER_SHIP_FEE_REDUCTION = 3;

export const BRANDING_NAME = {
    [MISFITS_THEME_DOMAIN]: 'Misfits+',
    [IMPERFECT_THEME_DOMAIN]: 'Imperfect+',
};

export const SHORT_BRANDING_NAME = {
    [MISFITS_THEME_DOMAIN]: 'M+',
    [IMPERFECT_THEME_DOMAIN]: 'IF+',
};

export const AVERAGE_MEMBERSHIP_SAVINGS = {
    dbi: {
        year: 373.88,
    },
    cs: {
        year: 479.96,
    },
};

export const CART_SAVINGS_BANNER_DISMISSED = 'CART-SAVINGS-BANNER-DISMISSED';
export const M_PLUS_IN_YOUR_FACE_CART_SAVINGS_BANNER_DISMISSED = 'M-PLUS-IN-YOUR-FACE-CART-SAVINGS-BANNER-DISMISSED';
